export const browserStorageKeys = {
  openOnAppPagePath: 'openOnAppPagePath',
  storedPageForRedirection: 'storedPageForRedirection',
  newMarketProductInfo: 'newMarketProductInfo',
  newOpenMarketProductInfo: 'newOpenMarketProductInfo',
  newUsersOwnProductInfo: 'newUsersOwnProductInfo',
  userTempData: 'userTempData',
  login: 'login',
  hasNewPoke: 'hasNewPoke',
  hasOwnTractor: 'hasOwnTractor',
  // User Region Depth 1, 민감한 정보이므로 단축어 사용
  urd1: 'urd1',
  visitedCountPDP: 'visitedCountPDP',
  visitedCountODP: 'visitedCountODP',
  visitedCountTLP: 'visitedCountTLP',
  visitedCountTDP: 'visitedCountTDP',
  executedPokeCount: 'executedPokeCount',
  userOwnTractorImageExists: 'userOwnTractorImageExists',
  advertisementTermsAgreement: 'advertisementTermsAgreement',
  clickedPendingProductId: 'clickedPendingProductId',
  managedFarmTaskList: 'managedFarmTaskList',
} as const;

export type browserStorageKeyType = keyof typeof browserStorageKeys;
